<template>
  <div class="DecodeTokenPage">
    <router-view v-if="!isWaitingForSaleServicePointData"></router-view>
  </div>
</template>

<script>
import store from '@/store';
import FullViewLoading from '@/components/Common/FullViewLoading';
import ManageTokenService from '@/services/ManageTokenService';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'DecodeTokenPage',
  components: { FullViewLoading },
  store,
  props: {
    token: {
      type: String,
      default: '',
    },
  },
  methods: {
    ...mapActions(['getSaleServicePointSettingsByToken', 'changeLoadingState']),
  },
  computed: {
    ...mapGetters(['tokenIsValid', 'isWaitingForSaleServicePointData']),
  },
  async mounted() {
    const token = ManageTokenService.getTokenFromStorage() || this.token;
    if (token) {
      await this.getSaleServicePointSettingsByToken(token);
    } else {
      this.changeLoadingState(false);
      this.$router.push({ path: '/info' });
      return;
    }

    if (this.tokenIsValid) {
      ManageTokenService.addTokenToStorage(token);
      this.$router.push({ path: '/pay' });
    } else {
      ManageTokenService.removeTokenFromStorage();
      this.$router.push({ path: '/error' });
    }
  },
};
</script>

<style lang="sass" scoped>
.DecodeTokenPage
  position: relative
  width: 100%
  height: 100%
</style>




// WEBPACK FOOTER //
// src/views/DecodeTokenPage.vue